import SelectSegmentDate from './ui/SelectSegmentDate/SelectSegmentDate.css';
export default {
    SelectSegmentDate
};
